import { useEffect } from 'react';

const favicons = [
  { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/static/img/favicon/favicon-16.png' },
  { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/static/img/favicon/favicon-32.png' },
  { rel: 'apple-touch-icon', sizes: '180x180', href: '/static/img/favicon/apple-touch-icon.png' },
  { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/static/img/favicon/android-chrome-192x192.png' },
  { rel: 'icon', type: 'image/png', sizes: '512x512', href: '/static/img/favicon/android-chrome-512x512.png' },
];

export const useDocumentMeta = (title, themeColor) => {
  useEffect(() => {
    // Add favicons only once
    if (!document.querySelector("link[rel='icon'][href*='favicon']")) {
      favicons.forEach(favicon => {
        const link = document.createElement('link');
        link.rel = favicon.rel;
        if (favicon.type) {
          link.type = favicon.type;
        }
        if (favicon.sizes) {
          link.sizes = favicon.sizes;
        }
        link.href = favicon.href;
        document.getElementsByTagName('head')[0].appendChild(link);
      });
    }

    if (title) {
      document.title = `${title} - 0-0 Studio`;
    }
    
    if (themeColor) {
      const metaThemeColor = document.querySelector("meta[name=theme-color]");
      if (metaThemeColor) {
        metaThemeColor.setAttribute("content", themeColor);
      } else {
        const meta = document.createElement('meta');
        meta.name = "theme-color";
        meta.content = themeColor;
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
    }

    // iOS Safari용
    const metaAppleStatusBar = document.querySelector("meta[name=apple-mobile-web-app-status-bar-style]");
    if (metaAppleStatusBar) {
      metaAppleStatusBar.setAttribute("content", "black-translucent");
    } else {
      const meta = document.createElement('meta');
      meta.name = "apple-mobile-web-app-status-bar-style";
      meta.content = "black-translucent";
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

  }, [title, themeColor]);
};